var has = Object.prototype.hasOwnProperty;
module.exports = Object.assign || function assign(target, source) {
	for (var key in source) {
		if (has.call(source, key)) {
			target[key] = source[key];
		}
	}
	return target;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/helpers/assign.js
 ** module id = 14
 ** module chunks = 0
 **/